var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.47679 19.9998H0.330357V6.64712H4.47679V19.9998ZM2.40134 4.82569C1.07545 4.82569 0 3.72748 0 2.40158C9.49017e-09 1.76471 0.252998 1.15392 0.703336 0.70358C1.15367 0.253242 1.76446 0.000244141 2.40134 0.000244141C3.03821 0.000244141 3.649 0.253242 4.09934 0.70358C4.54968 1.15392 4.80268 1.76471 4.80268 2.40158C4.80268 3.72748 3.72679 4.82569 2.40134 4.82569ZM19.9955 19.9998H15.858V13.4998C15.858 11.9507 15.8268 9.96408 13.7022 9.96408C11.5464 9.96408 11.2161 11.6471 11.2161 13.3882V19.9998H7.07411V6.64712H11.0509V8.46855H11.1089C11.6625 7.41944 13.0147 6.3123 15.0321 6.3123C19.2286 6.3123 20 9.07569 20 12.665V19.9998H19.9955Z","fill":"white"}));
}

LinkedinInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
